<template>
	<dms-wrapper :label="labelText" :show-label="!isHiddenLabel && showLabel" v-bind="{span, wrapp, validationRules, 'data-cy': `SELECT_${labelKey}`}"
		:validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-row type="flex" class="frm-subgroup frm-nowrap-group frm-selectgrid" :class="{'frm-item-label-margin': noLabelAlign}">
			<div class="frm-selectgrid-inp-group">
				<slot />
			</div>
			<dms-button-group :wrap="false">
				<dms-button v-if="isEditable || isViewable" :disabled="false" :wrapp="false" :icon="openEditIcon" data-cy="chooseSelectGrid" @click="openEdit" />
				<slot name="buttons" />
				<template v-if="!useButtonsSlots">
					<dms-tooltip v-if="isSelectable" :content="LocalizePopisPoli('SEARCH')" popper-class="btn-tooltip">
						<dms-button :disabled="isDisabled" :wrapp="false" icon="el-icon-search" data-cy="search"
							@click="openGrid" />
					</dms-tooltip>
				</template>
				<dms-tooltip :content="LocalizePopisPoli('CLEAR')" popper-class="btn-tooltip">
					<dms-button v-if="isClearable" :disabled="isDisabled" :wrapp="false" icon="el-icon-close" data-cy="removeSelectGrid"
						@click="clearSlot" />
				</dms-tooltip>
			</dms-button-group>
			<slot name="buttonsEnd" />
		</el-row>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsSelectGrid',
	components: { DmsWrapper },
	props: {
		afterSelectRowHandler: { type: Function },
		isEditable: { type: Boolean, default: false },
		isViewable: { type: Boolean, default: false },
		isSelectable: { type: Boolean, default: true },
		isClearable: { type: Boolean, default: true },
		noLabelAlign: { type: Boolean, default: false },
	},
	computed: {
		useButtonsSlots() {
			return this.$slots.buttons;
		},
		openEditIcon() {
			return this.isEditable ? 'el-icon-edit' : 'el-icon-view';
		},
	},
	methods: {
		openGrid() {
			this.$emit('openGrid');
		},
		clearSlot() {
			this.$emit('clear');
		},
		openEdit() {
			this.$emit('openEdit');
		},
	},
});
</script>

<style scoped lang="scss">
	::v-deep .frm-selectgrid-inp-group .frm-group {
		margin-bottom: 0;
	}
</style>
